import { ProcessingBadge } from '@saas-pages/shared/public/app-shell'
import { buildIndexCards } from '@/pages/index/indexCards'
import { useT } from '@/shared/i18n'
import { mediatikUtilityRegistry } from '@/shared/utility-registry'

export function IndexPage() {
  const t = useT()
  const cards = buildIndexCards(mediatikUtilityRegistry, t)
  return (
    <div className="mx-auto max-w-6xl">
      <div className="mb-2 sm:mb-3">
        <ProcessingBadge variant="local" label={t.common.local} title={t.common.noUpload} />
      </div>
      <h1 className="text-2xl font-bold tracking-normal sm:text-4xl">{t.home.title}</h1>
      <p className="mt-2 max-w-3xl text-sm leading-6 text-muted-foreground sm:text-base sm:leading-7">{t.home.description}</p>
      <section id="tools" className="mt-4 grid gap-3 sm:mt-6 sm:gap-4 md:grid-cols-3">
        {cards.map(({ route, icon, title, detail }) => (
          <a
            key={route.routeKey}
            href={route.path}
            className="flex items-start gap-3 rounded-xl border bg-card p-4 shadow-sm transition-colors hover:border-primary/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 sm:p-5 md:flex-col"
          >
            <span aria-hidden="true" className="flex size-11 shrink-0 items-center justify-center rounded-full bg-primary text-lg text-primary-foreground">{icon}</span>
            <span className="min-w-0">
              <h2 className="text-lg font-semibold tracking-normal">{title}</h2>
              <span className="mt-1 block text-sm leading-6 text-muted-foreground">{detail}</span>
            </span>
          </a>
        ))}
      </section>
    </div>
  )
}
